export default __webpack_public_path__ + "static/media/036-padlock.2282941d.png";